// extracted by mini-css-extract-plugin
module.exports = {"footerRoot":"footer_footerRoot__1qGij","backButton":"footer_backButton__2nUT6","backIcon":"footer_backIcon__3xMMf","disconnectButton":"footer_disconnectButton__1A4Hw"};